/**
 * Intelligence Layer
 *
 * Condition-specific content and test result interpretation.
 */

export {
  CONDITION_CONTENT_REGISTRY,
  getConditionContentForStep,
} from "./conditionContent";
export type { ConditionStepContent } from "./conditionContent";

export {
  useTestResultInsights,
  resultInterpretationKey,
} from "./useTestResultInsights";
export type { ResultInterpretation } from "./useTestResultInsights";
